<template>
    <div
        class="w-full overflow-hidden"
        :style="{
            height: height,
            width: width,
            borderRadius: rounded,
        }"
    >
        <div class="h-full w-full" :class="[baseClass, animationClasses[type]]"></div>
    </div>
</template>

<script lang="ts" setup>

//none-无动画 wave - 从上往下垂直波浪 ， fade - 淡入淡出  pulse- 脉动淡入淡出  shimmer-水平光条动画 flow-从左往右
interface Props {
  height?: string
  width?: string
  rounded?: string
  type?: 'shimmer' | 'pulse' | 'wave' | 'fade' | 'none'| 'flow'
  baseColor?: string
  highlightColor?: string
}

const {
  height = '100%',
  width = '100%',
  rounded = '4px',
  type = 'shimmer',
  baseColor = 'rgba(255, 255, 255, 0.2)',
  highlightColor = 'bg-gray-300 dark:bg-gray-600'
} = defineProps<Props>()

const baseClass = computed(() => {
  return type === 'none' ? baseColor : ''
})

const animationClasses:any = {
  shimmer:`animate-shimmer bg-gradient-to-r ${baseColor} from-10% via-${highlightColor} via-50% to-${baseColor} to-90%`,
  pulse: `animate-pulse ${baseColor}`,
  wave: `animate-wave ${baseColor} overflow-hidden relative`,
  fade: `animate-fade ${baseColor}`,
  flow: `animate-flow ${baseColor} overflow-hidden relative`
}
</script>

<style lang="scss" scoped>
/* Shimmer 效果 - 水平光条动画 */
@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

.animate-shimmer {
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite linear;
}

/* Pulse 效果 - 脉动淡入淡出 */
@keyframes pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Wave 效果 - 垂直波浪动画 */
@keyframes wave {
    0% {
        transform: translateY(-100%);
    }
    100% {
        transform: translateY(100%);
    }
}

.animate-wave::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.5), transparent);
    animation: wave 1.5s linear infinite;
}

.dark .animate-wave::after {
    background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.3), transparent);
}

/* Fade 效果 - 淡入淡出 */
@keyframes fade {
    0% {
        opacity: 0.3;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0.3;
    }
}

.animate-fade {
    animation: fade 2s ease-in-out infinite;
}

@keyframes flow {
  0% {
    transform: translateX(-100%) skewX(-15deg);
  }
  100% {
    transform: translateX(100%) skewX(-15deg);
  }
}
/* 从左到右流动光条 (flow) */
.animate-flow::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: flow 2s ease-in-out infinite;
}

.dark .animate-flow::after {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
}
</style>
